import React, { useEffect, useState } from 'react';
import { Joyride, STATUS } from 'react-joyride';

// Solo Onboarding Turu — yeni kullanıcı Dashboard'a ilk kez girdiğinde
// 4 adımlı interaktif tur çalışır. İlk 60 saniye içinde Solo değerini
// gösterir → trial-to-paid dönüşümünü artırmayı hedefler.
// Bir kez gösterilir (localStorage flag). Kullanıcı istediği zaman
// Yardım sayfasından tekrar tetikleyebilir (ileride eklenebilir).
const TOUR_STORAGE_KEY = 'solo_onboarding_tour_seen_v1';

const SoloOnboardingTour = ({ isSoloPlan }) => {
  const [run, setRun] = useState(false);

  // Tur şu koşullarda çalışır:
  //  1. Kullanıcı Solo plandaysa
  //  2. Daha önce turu görmediyse (localStorage bayrağı)
  useEffect(() => {
    if (!isSoloPlan) return;
    try {
      const seen = localStorage.getItem(TOUR_STORAGE_KEY);
      if (seen === '1') return;
      // Dashboard bileşenlerinin render'ını beklemek için küçük gecikme
      const t = setTimeout(() => setRun(true), 1500);
      return () => clearTimeout(t);
    } catch (_) { /* localStorage yasak / private mode → sessizce yut */ }
  }, [isSoloPlan]);

  const handleCallback = (data) => {
    const { status } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      try { localStorage.setItem(TOUR_STORAGE_KEY, '1'); } catch (_) { /* noop */ }
      setRun(false);
    }
  };

  const steps = [
    {
      target: '[data-testid="solo-kpi-row"]',
      title: 'Solo Değerine Bakış',
      content:
        'Bu üst satır, bu ay/bu yıl harcamalarınızı ve düzenli ödemelerinizi tek bakışta gösterir. Örnek verilerle nasıl görüneceğini şimdiden deneyebilirsiniz.',
      disableBeacon: true,
      placement: 'bottom',
    },
    {
      target: '[data-testid="solo-top-suppliers"]',
      title: 'İşletmelere Göre Dağılım',
      content:
        'Hangi firmaya ne kadar harcadığınızı sıralanmış olarak görürsünüz. Tıklayarak sadece o işletmenin harcamalarını filtreleyebilirsiniz.',
      placement: 'top',
    },
    {
      target: '[data-testid="solo-monthly-trend"]',
      title: 'Aylık Trend Grafiği',
      content:
        'Son 6 ay harcama trendiniz burada. Yıldan-yıla karşılaştırma için İşletmeler\'nden ilgili firmaya bakabilirsiniz.',
      placement: 'top',
    },
    {
      target: '[data-testid="quick-new-expense"]',
      title: 'İlk Kendi Harcamanızı Ekleyin',
      content:
        'Tek tıkla harcama eklemenin en hızlı yolu. Örnek veriler size fikir versin diye orada — hazır olduğunuzda Ayarlar > Örnek Veriler\'den silebilirsiniz.',
      placement: 'top',
    },
  ];

  if (!isSoloPlan) return null;

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showSkipButton
      showProgress
      disableScrolling={false}
      callback={handleCallback}
      locale={{
        back: 'Geri',
        close: 'Kapat',
        last: 'Bitti',
        next: 'İleri',
        skip: 'Turu atla',
      }}
      styles={{
        options: {
          primaryColor: '#0d9488',    // teal-600
          textColor: '#111827',        // gray-900
          backgroundColor: '#ffffff',
          overlayColor: 'rgba(0,0,0,0.5)',
          zIndex: 10000,
        },
        tooltip: { borderRadius: 12, padding: 16 },
        tooltipTitle: { fontSize: 16, fontWeight: 700, marginBottom: 6 },
        tooltipContent: { fontSize: 13, lineHeight: 1.5 },
        buttonNext: { borderRadius: 8, padding: '8px 16px', fontWeight: 600 },
        buttonBack: { color: '#6b7280', marginRight: 8 },
        buttonSkip: { color: '#9ca3af' },
      }}
    />
  );
};

export default SoloOnboardingTour;
